import type {Tag} from '../hooks/useTasks.js';

export function TagChips({tags}: {tags: Tag[] | undefined}) {
  if (!tags?.length) return null;
  return (
    <span className="tag-chip-row">
      {tags.map(tag => <span key={tag.id} className="tag-chip" style={tag.color ? {borderColor: tag.color, color: tag.color} : undefined}>{tag.name}</span>)}
    </span>
  );
}
